import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogContent, DialogCustomActions } from "../models/dialogContent";
import { AppHelper } from "./app.helper";
import { DialogBodyComponent } from "../components/dialogs/dialog-body.component";
import { Session } from "../models/WebServer/session";
import { TranslateService } from "@ngx-translate/core";
import { I18Service } from "../services/i18.service";
import { FELoggerService, LogSource } from "../services/feLogger.service";
import { PartecipantRoles } from "../models/WebServer/partecipantRoles";
import { AppConfigService } from "../services/app.config.service";
import { AgencySettings } from "../models/WebServer/agencySettings";
import { Injectable } from "@angular/core";


type DisclaimerHelpItem = {
    sessionId: string,
    accepted: boolean,
    timestamp: number
}
@Injectable({
    providedIn: 'root'
  })
export class DisclaimerHelper {

    static readonly DISCLAIMER_PREF = 'DisclaimerPref';
    private static s_matDialog: MatDialog;
    private static s_config: AppConfigService;
    constructor(config: AppConfigService, matDialog: MatDialog) {
        console.debug(`***************** DisclaimerHelper constructor`)
        DisclaimerHelper.s_matDialog = matDialog; 
        DisclaimerHelper.s_config = config;
        
    }

    static showDisclaimer(onOpenCkb: any = undefined): Promise<boolean> {
        const promise: Promise<boolean > = new Promise<boolean >( resolve => {
            // Usa il metodo centralizzato per check se disclaimer già accettato
            if (this.shouldDisclaimerBeAccepted()) {
                resolve(true);
                return;
            }

            // Se arriviamo qui, disclaimer deve essere mostrato
            // cerca il disclaimer corretto
            var disclaimer = DisclaimerHelper.s_config.agencySettings.disclaimers
                .find( z => z.for == AppConfigService.role && z.language == I18Service.language && z.title)
            if (!disclaimer) disclaimer = DisclaimerHelper.s_config.agencySettings.disclaimers
                .find( z => z.for == PartecipantRoles.SecondaryClient && z.language == I18Service.language && z.title)
            if (!disclaimer) disclaimer = DisclaimerHelper.s_config.agencySettings.disclaimers
                .find( z => z.for == PartecipantRoles.SecondaryClient && z.language == DisclaimerHelper.s_config.agencySettings.defaultLanguage && z.title)
            
            if (!disclaimer) {
                FELoggerService.warn(`disclaimer enabled but NOT CONFIGURED! (autoresolve) - USING DEFAULT TEXT`)
            }
            
            const title=disclaimer?.title || `Disclaimer`;
            const htmlText=disclaimer?.text || ``;
            var html=`<div class="disclaimer-body"><pre>${htmlText}</pre></div>`
            if (!htmlText){
                const role = '';
//                var disclaimerUrl = `/assets/disclaimers/${DisclaimerHelper.s_config.agencySettings.agency.toLowerCase()}/disclaimer${role}.html`;
//                if (!AppHelper.fileExists(disclaimerUrl)) {
                  
                  const  disclaimerUrl = `/assets/disclaimers/_default/disclaimer${role}.html`;
//                }

                console.log(`showDisclaimer`, disclaimerUrl)
                html = AppHelper.loadTextFile(disclaimerUrl);
            }
            
            const cancelButton = I18Service.get('POPUP.CANCEL')
            const blockingDisclaimer = DisclaimerHelper.s_config.agencySettings.blockingDisclaimer;
            const disclaimerContent = new DialogContent(title, html, blockingDisclaimer, false);
            disclaimerContent.actions.push(new DialogCustomActions('OK', false, 1));
            blockingDisclaimer && disclaimerContent.actions.push(new DialogCustomActions(cancelButton, true, 2));
            const disclaimerDialogRef: MatDialogRef<DialogBodyComponent, any> = AppHelper.openDialog(DisclaimerHelper.s_matDialog, disclaimerContent, '80%', '80%');
            onOpenCkb && onOpenCkb(disclaimerDialogRef);
            disclaimerDialogRef.afterClosed().subscribe(ans => {
                console.log(`showDisclaimer ans: ${ans}`);
                const result = (ans==1) ? true : false;
                this.saveDisclaimerPref(DisclaimerHelper.s_config.sessionId!, result);
                resolve(result);
            });
        });
    // })
        return promise
    }




    /**
     * Verifica se il disclaimer dovrebbe essere considerato accettato,
     * replicando ESATTAMENTE la logica di showDisclaimer() ma senza mostrare UI.
     * Usato durante reconnect per ripristinare lo stato senza interazione utente.
     *
     * @returns true se disclaimer è accettato (o non richiesto), false altrimenti
     */
    public static shouldDisclaimerBeAccepted(): boolean {
        // Check 1: disclaimer non richiesto dall'agency
        if (!DisclaimerHelper.s_config.agencySettings.showDisclaimer) {
            return true;
        }

        // Check 2: già accettato in localStorage (con timeout)
        if (this.checkDisclaimerPref(
            DisclaimerHelper.s_config.sessionId!,
            DisclaimerHelper.s_config.agencySettings.disclaimerMinTimeout
        )) {
            return true;
        }

        // Se arriviamo qui, disclaimer deve essere mostrato/accettato
        return false;
    }

    private static checkDisclaimerPref(sessionId:string, timeoutInMin: number): boolean {
        const key=`${DisclaimerHelper.DISCLAIMER_PREF}.${AppConfigService.role}`
        const disclPref = localStorage.getItem(key);
        if (disclPref) {
            try {
                const saved: DisclaimerHelpItem = JSON.parse(disclPref);
                if (saved.sessionId !== sessionId) return false;
                if (!saved.accepted) return false;
                const diffTimeInMin = Math.floor( ((new Date()).getTime() - saved.timestamp) / (1000*60) );
                if (diffTimeInMin < timeoutInMin) return true;
            } catch(e){ FELoggerService.warn(`checkDisclaimerPref`, LogSource.Default, e)}
        }

        return false;
    }
    private static saveDisclaimerPref(sessionId: string, accepted: boolean) {
        const key=`${DisclaimerHelper.DISCLAIMER_PREF}.${AppConfigService.role}`
        const disclaimer: DisclaimerHelpItem = {
            sessionId: sessionId,
            accepted,
            timestamp: (new Date()).getTime()
        }
        localStorage.setItem(key, JSON.stringify(disclaimer));
    }
}